import React from "react";
import "./ppr-button.less";

interface ButtonProps extends React.PropsWithChildren {
  text: string;
  type?: "primary" | "secondary";
  size?: "small" | "medium" | "large";

  icon?: string;
  iconType?: string;
  iconPosition?: "left" | "right";

  isFocus?: boolean;
  delayFocus?: number;
  disable?: boolean;
  onClick?: () => void;
  className?: string;
  hoverable?: boolean;
}

const PprButton = (props: ButtonProps) => {
  const icononly = props.icon && !props.text && (
    <div className="icon-only">
      <i
        className={`fa ${props.iconType} fa-${props.icon} ppr-btn-icon`}
        aria-hidden="true"
      ></i>
    </div>
  );

  const icontext = props.icon && props.text && (
    <i
      className={`fa ${props.iconType} fa-${props.icon} ppr-btn-icon`}
      aria-hidden="true"
    ></i>
  );

  const textonly = props.text && (
    <span className="button-text">{props.text}</span>
  );

  return (
    <button
      rel="noreferrer"
      ref={(btn) => {
        if (props.isFocus) {
          setTimeout(() => btn?.focus(), props.delayFocus ?? 0);
        }
      }}
      className={`ppr-button ${props.hoverable === false && "not-hoverable"} ${props.type ?? "primary"} ${props.size ?? "medium"} ${props.className}`}
      onClick={props.onClick}
      disabled={props.disable}
    >
      <div className={`btn-content ${props.iconPosition ?? "left"}`}>
        {icononly}
        {icontext}
        {textonly}
      </div>
    </button>
  );
};

export default PprButton;
